<template>
  <div>
    <div class="openclose-directory-dialog">
      <v-btn rounded icon @click="showDirectory=!showDirectory">
        <v-icon :size="icon_size">mdi-folder-multiple-outline</v-icon>
      </v-btn>
      </div>
      <v-dialog
        v-model="showDirectory"
        :content-class="''+(size == 'small' ? 'qmkey-small-dialog' : '')"
      >
        <div class="white">
          <ExplorerDirectory
            @update="update_filters"
            ref="explorer_directory"
            :filters="filters"
          ></ExplorerDirectory>
      </div>
    </v-dialog>
  </div>
</template>
  
  
<style lang="scss">
  @import "@/sass/explorer.scss";
  .qmkey-small-dialog {
    width: auto !important;
  }
</style>
  
  
<script>
  import ExplorerDirectory from '@/components/explorer/ExplorerDirectory';
  
  
  export default {
    name: 'ExplorerDirectoryMobile',
  
    components: {
      ExplorerDirectory
    },
    
    props: {
      filters: {},
      is_mobile: {type: Boolean, defalut: false},
      size: {default: 'auto'},
      icon_size: {default: 'small'},
    },
  
    data: () => ({
      showDirectory: false,
      close: false,
    }),
  
    mounted() {
      this.close = this.is_mobile;
    },
  
    methods: {
      update_filters(ef) {
        this.$emit('update', ef);
      },
    },
  
    watch: {
      is_mobile(isMobile) {
        if (!isMobile) {
          this.close = false;
        }
      },
      close(closed) {
        this.$emit('opened', !closed);
      }
    },
  };
</script>
  